import { api } from "@/utils/client";
import { keyBy } from 'lodash-es';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        ids: [],
        list: {},
        meta: {},
        selected: undefined,
        showingDeleted: false,
        localFonts: [
            { name: 'Arial', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Arial Black', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Comic Sans MS', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Times', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Times New Roman', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Helvetica', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Courier', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Courier New', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Verdana', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Tahoma', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Impact', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Georgia', variants: [{ italic: false, weight: 400 }, '1,400' ] },
            { name: 'Garamond', variants: [{ italic: false, weight: 400 }, '1,400' ] }
        ]
    },
    getters: {
        orderedList(state) {
            return state.ids.map(id => state.list[id]);
        },
        selected(state) {
            return state.list[state.selected];
        },
        localFonts(state) {
            return state.localFonts;
        }
    },
    mutations: {
        setList(state, list) {
            state.ids = list.map(({id}) => id)
            state.list = keyBy(list, 'id');
        },
        addItem(state, {id, ...item}) {
            state.ids = [id, ...state.ids];
            Vue.set(state.list, id, {id, ...item})
        },
        updateItem(state, {id, ...item}) {
            if (!state.ids.includes(id)) {
                state.ids = [id, ...state.ids];
            }
            Vue.set(state.list, id, {id, ...item})
        },
        removeItem(state, id) {
            state.ids = state.ids.filter((_id) => _id !== id);
            Vue.delete(state.list, id)
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
        setShowingDeleted(state, showingDeleted) {
            state.showingDeleted = showingDeleted;
        },
    },
    actions: {
        async getList({commit, state, rootState}, params = {}) {
            const {data: {data, meta}} = await api.get(`teams/${rootState.teamId}/themes`, {
                params: {
                    ...params,
                    deleted: state.showingDeleted ? 1 : 0
                }
            })
            commit('setList', data);
            commit('setMeta', meta);
            return data;
        },
        async getById({commit, rootState}, id) {
            const {data: {data}} = await api.get(`teams/${rootState.teamId}/themes/${id}`,)
            commit('addItem', data);
            return data;
        },
        async getBySlug({commit, rootState}, slug) {
            const {data: {data}} = await api.get(`teams/${rootState.teamId}/themes/slug/${slug}`,)
            commit('addItem', data);
            return data;
        },
        async create({commit, rootState}, payload) {
            const {data: {data}} = await api.post(`teams/${rootState.teamId}/themes`, payload)
            commit('addItem', data);
            return data;
        },
        async update({commit, rootState}, {id, ...payload}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/themes/${id}`, payload)
            commit('updateItem', data);
            return data;
        },
        async publish({commit, rootState}, {id}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/themes/${id}/publish`)
            commit('updateItem', data);
            return data;
        },
        async unpublish({commit, rootState}, {id}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/themes/${id}/unpublish`)
            commit('updateItem', data);
            return data;
        },
        async delete({commit, rootState}, id) {
            await api.delete(`teams/${rootState.teamId}/themes/${id}`)
            commit('removeItem', id);
        },
        async restore({commit, rootState}, id) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/themes/${id}/restore`)
            commit('updateItem', data);
            return data;
        },
        async forceDelete({commit, rootState}, id) {
            const {data: {data}} = await api.delete(`teams/${rootState.teamId}/themes/${id}`, {data: {permanent: true}})
            commit('removeItem', id);
            return data;
        },
    }

}
